const pagesTitles = {
  adminsManagement: "Admins management",
  admins: "List admins",
  adminsAdd: "Add new admin",
  adminsEdit: "Edit admin",
  subCategoriesManagement: "Sub Categories management",
  serviceProviderSubCategories: "Sub Categories List",
  serviceProviderSubCategoriesAdd: "Add new sub category",
  serviceProviderSubCategoriesEdit: "Edit sub category",
  serviceProviderSubCategoriesView: "View sub category",
  specialtiesManagement: "Specialties management",
  specialties: "Specialties",
  specialtiesAdd: "Add new specialty",
  specialtiesView: "View specialty",
  specialtiesEdit: "Edit specialty",
  servicesManagement: "Services management",
  services: "Services",
  servicesAdd: "Add new service",
  servicesEdit: "Edit service",
  serviceProvidersManagement: "Service Providers management",
  serviceProviders: "Service providers",
  serviceProvidersAdd: "Add new service provider",
  serviceProvidersEdit: "Edit service provider",
  serviceProvidersView: "View service provider"
};

export default pagesTitles;
